import React from 'react';
import { DModal, DPageLoader } from '../../../../../dum';
import { OrderRequestIcon } from '../../../../icons';
import { OrderRequestDetailsChangeForm } from './order-request-details-change-form';
import { useOrderRequestDialogQuery } from '../../../../../../services';

interface ISUpdateOrderRequestDetailsDialogProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    orderRequestId: number | null;
}

export function SUpdateOrderRequestDetailsDialog({
    open,
    setOpen,
    orderRequestId,
}: ISUpdateOrderRequestDetailsDialogProps) {
    // Fetches fresh by id rather than reusing the row object the list already
    // had in memory — otherwise this dialog can reopen with whatever the list
    // last fetched, which goes stale the moment the list itself doesn't refetch
    // in between edits.
    const { data, loading } = useOrderRequestDialogQuery({
        skip: !orderRequestId || !open,
        variables: {
            OrderRequestId: orderRequestId!,
        },
    });

    const orderRequest =
        orderRequestId && data && data.getOrderRequest && open
            ? data.getOrderRequest
            : undefined;

    return (
        <DModal
            icon={<OrderRequestIcon />}
            title={'Editar datos opcionales'}
            open={open}
            setOpen={setOpen}
        >
            {loading ? (
                <DPageLoader />
            ) : orderRequestId ? (
                <OrderRequestDetailsChangeForm
                    orderRequestId={orderRequestId}
                    currentNotes={orderRequest?.notes}
                    currentEstimatedDeliveryDate={
                        orderRequest?.estimated_delivery_date
                    }
                    onSuccess={() => setOpen(false)}
                />
            ) : null}
        </DModal>
    );
}
